module.exports = __webpack_public_path__ + "img/INSERT_PAST.a3f3d45d.svg";